export const uniqueErrorMessages = <T extends string | { message: string } | undefined>(errs: T[]): Exclude<T, undefined>[] => {
  const seen = new Set<string>();
  return errs.flatMap((err) => {
    if (err === undefined) {
      return [];
    }
    const msg = typeof err === "string" ? err : err.message;
    if (seen.has(msg)) {
      return [];
    }
    seen.add(msg);
    return [err];
  }) as Exclude<T, undefined>[];
};
